

class FAQ2Section {
  constructor(container) {
    this.container = container;
    this.faqItems = container.querySelectorAll('[data-faq-item]');
    this.modal = container.querySelector('[data-video-modal]') || document.querySelector('[data-video-modal]');
    this.videoContainer = this.modal?.querySelector('[data-video-container]');
    this.modalCloseButtons = this.modal ? this.modal.querySelectorAll('[data-modal-close]') : [];

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupInitialState();
  }

  bindEvents() {
    this.faqItems.forEach(item => {
      const trigger = item.querySelector('[data-faq-trigger]');
      if (trigger) {
        trigger.addEventListener('click', this.handleFAQToggle.bind(this, item));
        trigger.addEventListener('keydown', this.handleFAQKeydown.bind(this, item));
      }
    });
    document.addEventListener('click', (e) => {
      const videoTrigger = e.target.closest('[data-video-trigger]');
      if (videoTrigger) {
        this.handleVideoClick(e);
      }
    });
    this.modalCloseButtons.forEach(button => {
      button.addEventListener('click', this.closeModal.bind(this));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal && this.modal.style.display !== 'none') {
        this.closeModal();
      }
    });
    document.addEventListener('shopify:section:load', this.handleSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this.handleSectionUnload.bind(this));
  }

  setupInitialState() {
    if (this.faqItems.length > 0) {
      const firstItem = this.faqItems[0];
      this.expandFAQ(firstItem, false);
    }
  }

  handleFAQToggle(item, e) {
    e.preventDefault();
    
    const isExpanded = item.getAttribute('data-faq-expanded') === 'true';
    
    if (isExpanded) {
      this.collapseFAQ(item);
    } else {
      this.expandFAQ(item);
    }
  }

  handleFAQKeydown(item, e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.handleFAQToggle(item, e);
    }
  }

  expandFAQ(item, animate = true) {
    const trigger = item.querySelector('[data-faq-trigger]');
    const content = item.querySelector('[data-faq-content]');

    if (!trigger || !content) return;
    item.setAttribute('data-faq-expanded', 'true');
    trigger.setAttribute('aria-expanded', 'true');

    const iconPlus = trigger.querySelector('.icon-plus');
    const iconMinus = trigger.querySelector('.icon-minus');
    if (iconPlus) iconPlus.classList.add('hidden');
    if (iconMinus) iconMinus.classList.remove('hidden');

    if (animate) {
      content.style.display = 'block';
      const height = content.scrollHeight;
      content.style.height = '0px';
      content.style.overflow = 'hidden';
      content.style.transition = 'height 0.3s ease';
      content.offsetHeight;

      content.style.height = height + 'px';

      setTimeout(() => {
        content.style.height = '';
        content.style.overflow = '';
        content.style.transition = '';
      }, 300);
    } else {
      content.style.display = 'block';
    }

  }

  collapseFAQ(item) {
    const trigger = item.querySelector('[data-faq-trigger]');
    const content = item.querySelector('[data-faq-content]');

    if (!trigger || !content) return;
    item.setAttribute('data-faq-expanded', 'false');
    trigger.setAttribute('aria-expanded', 'false');

    const iconPlus = trigger.querySelector('.icon-plus');
    const iconMinus = trigger.querySelector('.icon-minus');
    if (iconPlus) iconPlus.classList.remove('hidden');
    if (iconMinus) iconMinus.classList.add('hidden');

    const height = content.scrollHeight;
    content.style.height = height + 'px';
    content.style.overflow = 'hidden';
    content.style.transition = 'height 0.3s ease';
    content.offsetHeight;

    content.style.height = '0px';

    setTimeout(() => {
      content.style.display = 'none';
      content.style.height = '';
      content.style.overflow = '';
      content.style.transition = '';
    }, 300);

  }

  handleVideoClick(e) {
    e.preventDefault();
    
    const trigger = e.target.closest('[data-video-trigger]');
    if (!trigger) return;

    const videoUrl = trigger.getAttribute('data-video-url');
    const videoFile = trigger.getAttribute('data-video-file');

    if ((!videoUrl && !videoFile) || !this.modal || !this.videoContainer) {
      return;
    }

    
    if (videoFile) {
      this.openVideoModalFile(videoFile);
    } else {
      this.openVideoModal(videoUrl);
    }
  }

  openVideoModal(videoUrl) {
    if (!this.modal || !this.videoContainer) return;
    const embedUrl = this.getVideoEmbedUrl(videoUrl);
    if (!embedUrl) {
      return;
    }
    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.allowFullscreen = true;
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    this.videoContainer.innerHTML = '';
    this.videoContainer.appendChild(iframe);
    this.modal.style.display = 'flex';
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    const closeButton = this.modal.querySelector('[data-modal-close]');
    if (closeButton) {
      closeButton.focus();
    }

  }

  openVideoModalFile(videoFile) {
    if (!this.modal || !this.videoContainer) return;
    const video = document.createElement('video');
    video.src = videoFile;
    video.controls = true;
    video.autoplay = true;
    video.style.width = '100%';
    video.style.height = '100%';
    this.videoContainer.innerHTML = '';
    this.videoContainer.appendChild(video);
    this.modal.style.display = 'flex';
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    const closeButton = this.modal.querySelector('[data-modal-close]');
    if (closeButton) {
      closeButton.focus();
    }

  }

  closeModal() {
    if (!this.modal || !this.videoContainer) return;

    this.modal.classList.add('closing');

    setTimeout(() => {
      this.videoContainer.innerHTML = '';
      this.modal.classList.remove('active');
      this.modal.classList.remove('closing');
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);

  }

  getVideoEmbedUrl(url) {
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const youtubeMatch = url.match(youtubeRegex);
    
    if (youtubeMatch) {
      const videoId = youtubeMatch[1];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }
    const vimeoRegex = /(?:vimeo\.com\/)(?:.*\/)?([0-9]+)/i;
    const vimeoMatch = url.match(vimeoRegex);
    
    if (vimeoMatch) {
      const videoId = vimeoMatch[1];
      return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }
    if (url.includes('youtube.com/embed') || url.includes('player.vimeo.com')) {
      return url;
    }

    return null;
  }

  handleSectionLoad(e) {
    if (e.detail.sectionId === this.container.getAttribute('data-section-id')) {
      this.setupInitialState();
    }
  }

  handleSectionUnload(e) {
    if (e.detail.sectionId === this.container.getAttribute('data-section-id')) {
      this.closeModal();
    }
  }
  expandFAQByIndex(index) {
    if (this.faqItems[index]) {
      this.expandFAQ(this.faqItems[index]);
    }
  }
  collapseAllFAQs() {
    this.faqItems.forEach(item => {
      if (item.getAttribute('data-faq-expanded') === 'true') {
        this.collapseFAQ(item);
      }
    });
  }
}
function initFAQ2Sections() {
  const faq2Sections = document.querySelectorAll('[data-section-type="faq-2"]');
  
  faq2Sections.forEach(section => {
    if (!section.FAQ2Instance) {
      section.FAQ2Instance = new FAQ2Section(section);
    }
  });
  
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFAQ2Sections);
} else {
  initFAQ2Sections();
}
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('[data-section-type="faq-2"]')) {
    initFAQ2Sections();
  }
});

window.FAQ2Section = FAQ2Section;